import React from "react";
import { object, number } from "prop-types";

import CardImage from "../../../atoms/CardImage";
import Excerpt from "../../../atoms/Excerpt";
import PublishedAt from "../../../atoms/PublishedAt";
import NumberedHeadline from "../../../molecules/NumberedHeadline";

import { getExcerpt } from "../../../utils/utils";

import "./organism2.m.css";

const Organism2 = ({ story, headlineNumber }) => {
  if (!story) return null;

  return (
    <div styleName="wrapper">
      <div styleName="image-wrapper">
        <CardImage
          className="card-with-image-zoom"
          story={story}
          aspectRatio={[3, 2]}
          imageType="image3x2"
          linkEnable={true}
          widths={[400, 220, 380]}
        />
      </div>

      <NumberedHeadline story={story} headlineNumber={headlineNumber} />
      <Excerpt excerpt={getExcerpt(story)} url={story.url} />
      <PublishedAt date={story["last-published-at"]} className="published-time" />
    </div>
  );
};

Organism2.propTypes = {
  story: object.isRequired,
  headlineNumber: number,
};

export default Organism2;
